import { Session } from '@ais-ui/auth';

export type Filter = {
  enabled: boolean;
  filter: string;
  groups: string[];
  isEditable: boolean;
  name: string;
  owner: string;
  uuid: string;
};

export type IdFilter = {
  uuid: string;
};

export const getFilters = async (
  session: Session
): Promise<Filter[] | null> => {
  const response = await session.request('getFilterList', {});

  return response;
};

export const saveFilter = async (
  session: Session,
  filter: Filter
): Promise<IdFilter> => {
  const response = await session.request('saveFilter', {
    filter: filter,
  });

  return response;
};

export const deleteFilter = async (
  session: Session,
  uuid: string
): Promise<null> => {
  const response = await session.request('deleteFilter', {
    uuid: uuid,
  });

  return response;
};

export const setFilters = async (
  session: Session,
  filterExpression: string
): Promise<null> => {
  const response = await session.request('setFilter', {
    filterExpression: filterExpression,
    showFiltered: false,
  });

  return response;
};
